// extracted by mini-css-extract-plugin
export default {"menu":"SidebarMenu_menu__Rz-ie"};